/**
 * Traspaso de sesión entre pestañas: si esta pestaña fue abierta con
 * window.open() desde la app (opener del mismo origen) y todavía no tiene
 * sesión, copia TODO el sessionStorage del opener. Debe ejecutarse en
 * main.ts, antes del bootstrap de Angular (y por lo tanto antes del
 * LoginGuard).
 *
 * Las pestañas abiertas manualmente (URL pegada, bookmark) no tienen
 * opener y siguen pidiendo login, preservando la semántica actual de
 * sessionStorage (cerrar el navegador = logout).
 */
export function copiarSesionDesdeOpener(): void {
  try {
    // Ya hay sesión propia, no pisarla
    if (sessionStorage.getItem('accessToken')) return;
    const opener: Window | null = window.opener;
    // Pestaña manual, middle-click nativo o rel=noopener
    if (!opener) return;
    // Si el opener es cross-origin, esta línea lanza SecurityError
    const origen = opener.sessionStorage;
    // Opener deslogueado
    if (!origen.getItem('accessToken')) return;
    for (let i = 0; i < origen.length; i++) {
      const key = origen.key(i);
      if (key !== null) {
        sessionStorage.setItem(key, origen.getItem(key) ?? '');
      }
    }
    // One-shot: evita re-copiar la sesión si esta pestaña hace logout y recarga
    window.opener = null;
  } catch {
    // Opener cross-origin o storage inaccesible: seguir sin sesión (irá a login)
  }
}
